<template>
  <b-row>
    <b-col md="6" sm="12">
      <b-form-group>
        <label>{{$t('views.documenttype.list.title')}}:</label>
        <input
          class="form-control"
          v-model.lazy="filters['title']"
          v-debounce="delay"
          id="title"
          type="text"/>
      </b-form-group>
    </b-col>
    <b-col md="6" sm="12">
      <b-form-group>
        <label>{{$t('views.documenttype.list.subtitle')}}:</label>
        <input
          class="form-control"
          v-model.lazy="filters['subtitle']"
          v-debounce="delay"
          id="language"
          type="text"/>
      </b-form-group>
    </b-col>
    <b-col md="6" sm="12">
      <b-form-group>
        <label>{{$t('views.documenttype.list.language')}}:</label>
        <input
          class="form-control"
          v-model.lazy="filters['language']"
          v-debounce="delay"
          id="language"
          type="text"/>
      </b-form-group>
    </b-col>
    <b-col md="6" sm="12">
      <b-form-group>
        <label>{{$t('views.documenttype.list.version')}}:</label>
        <input
          class="form-control"
          v-model.lazy="filters['version']"
          v-debounce="delay"
          id="version"
          type="number"
          min="0"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import addParamsToQuery from '@/utils/addParamsToQuery'
import debounce from 'v-debounce'

export default {
  name: 'DocumentTypeFiltering',
  components: {

  },
  data () {
    return {
      delay: 500,
      filters: {
        'title': '',
        'subtitle': '',
        'language': '',
        'version': ''
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'document_types'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    }
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
